const TOKEN_KEY = "accessToken";
const API_ACCESS_TOKEN_KEY = "apiAccessToken";
const USER_ID_KEY = "userId";
const REFERRER_KEY = "ref";

export const setToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const setApiAccessToken = (token: string): void => {
  localStorage.setItem(API_ACCESS_TOKEN_KEY, token);
};

export const setUserId = (userId: string): void => {
  localStorage.setItem(USER_ID_KEY, userId);
};

export const getUserId = (): string | null => {
  return localStorage.getItem(USER_ID_KEY);
};

export const removeUserId = (): void => {
  localStorage.removeItem(USER_ID_KEY);
};

export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getApiAccessToken = (): string | null => {
  return localStorage.getItem(API_ACCESS_TOKEN_KEY);
};

export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

export const removeApiAccessToken = (): void => {
  localStorage.removeItem(API_ACCESS_TOKEN_KEY);
};

export const hasToken = (): boolean => {
  return !!localStorage.getItem(TOKEN_KEY);
};

export const hasApiAccessToken = (): boolean => {
  return !!localStorage.getItem(API_ACCESS_TOKEN_KEY);
};

export const setReferrer = (referrer: string): void => {
  localStorage.setItem(REFERRER_KEY, referrer);
};

export const getReferrer = (): string | null => {
  return localStorage.getItem(REFERRER_KEY);
};

export const removeReferrer = (): void => {
  localStorage.removeItem(REFERRER_KEY);
};

export const hasReferrer = (): boolean => {
  return !!localStorage.getItem(REFERRER_KEY);
};
